<template>
  <div style="margin: 0 40px;">
    <div>
      <el-descriptions title="身份已认证，但未归还的数据如下：" border :column="1" >
        <template #extra>
          <el-button type="primary" size="small" @click="getPage">刷新</el-button>
        </template>
        <el-descriptions-item align="center" width="50%" label="申请归还人数">{{allNum}} 人</el-descriptions-item>
      </el-descriptions>
<!--      <p style="margin-top: 16px;">归还成功人数：<span style="color:red;">{{successNum}}</span> 人</p>-->
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button size="medium" @click="cancel">返 回</el-button>
      <el-button type="primary" :disabled="!allNum"  @click="submit" v-loading="submitLoading">确认</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData, getFormData} from "@/api/api";
import {getAllBaoAplly, returnAllBaoAplly} from "@/api/url"

export default {
  name: "PassAllDialog",
  props: {
    value: Object
  },
  data() {
    return {
      idArray: this.value.idArray,
      msg: '你的提现未能通过审核，请填写正确的支付宝账号和实名。',
      submitLoading: false,
      allNum: 0,
      tableLoading: false,
      successNum: 0,
      isNew: true,
    }
  },
  methods: {

    //返回
    cancel() {
      // this.carForm = this.value.carForm,
      this.$emit('close');
    },

    getPage() {
      this.tableLoading = true;
      getFormData(getAllBaoAplly,{}).then((data) => {
        let {code, msg} = data
        if(code == 200) {
          this.allNum = data.data.allNum
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.isNew = true;
        // _this.successNum = 0;
        this.tableLoading = false;
      })
          .catch(function(data){})
    },

    //提交
    submit() {
      if(!this.isNew) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请刷新数据',
          type: 'warning'
        })
        return;
      }else{
        this.isNew = false;
      }
      this.$confirm('确认要全部归还吗？').then(() => {
        this.submitLoading = true;
        postFormData(returnAllBaoAplly, {}).then((data) => {
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.$emit('confirm')
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.submitLoading = false;
        })
      })
          .catch(() => {})
    }

  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
